import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "5 MB.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("b", null, "PNG, PDF, JPEG, BMP, HEIC, DOCX, DOC.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedBack = _resolveComponent("SharedBack")!
  const _component_SharedUpload = _resolveComponent("SharedUpload")!
  const _component_SharedValidate = _resolveComponent("SharedValidate")!
  const _component_SharedDownload = _resolveComponent("SharedDownload")!
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedCard = _resolveComponent("SharedCard")!

  return (_openBlock(), _createBlock(_component_SharedCard, {
    class: _normalizeClass(_ctx.b())
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createVNode(_component_SharedBack, { onClick: _ctx.handleBack }, null, 8, ["onClick"]),
        _createElementVNode("h3", {
          class: _normalizeClass(_ctx.b('header-title'))
        }, _toDisplayString(_ctx.$t("Загрузка документов")), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('upload'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Загрузите подтверждающие документы*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('upload-group'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-registration-company'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              "is-padding": false,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Сертификат о")) + " ", 1),
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("регистрации")) + " ", 1),
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("компании")), 1)
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-regulation",
            value: _ctx.documents['kyb-documents-regulation'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-regulation'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-regulation'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Устав*")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-list-of-shareholders'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Список акционеров")), 1)
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-license'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("Лицензия")), 1)
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-check-addresses",
            value: _ctx.documents['kyb-documents-check-addresses'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-check-addresses'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-padding": false,
                "is-error": 
              _ctx.isValidate && !_ctx.documents['kyb-documents-check-addresses'].id
            ,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('Подтверждение адреса регистрации*')
                  }, null, 8, _hoisted_6)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-sow'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              "is-padding": false,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Доказательства")) + " ", 1),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("источника дохода")) + " ", 1),
                _hoisted_8,
                _createTextVNode(" SoW ")
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-sof'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              "is-padding": false,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Доказательства")) + " ", 1),
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("источника средств")) + " ", 1),
                _hoisted_10,
                _createTextVNode(" SoF ")
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-inn",
            value: _ctx.documents['kyb-documents-inn'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-inn'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-inn'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Свидетельство")) + " ", 1),
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("ИНН*")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-record-sheet'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Лист Записи")), 1)
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-create",
            value: _ctx.documents['kyb-documents-create'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-create'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-padding": false,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-create'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Решение о создании*")) + " ", 1),
                  _hoisted_12,
                  _createElementVNode("span", {
                    innerHTML: _ctx.$t('Учредительный договор')
                  }, null, 8, _hoisted_13)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('shared-upload'))
          }, [
            _createVNode(_component_SharedUpload, {
              class: _normalizeClass(_ctx.b('shared-upload')),
              document: _ctx.documents['kyb-documents-update'],
              "is-readonly": _ctx.isReadonly,
              "is-loading": _ctx.isLoading,
              "is-padding": false,
              onUpload: _ctx.handleUploadFile,
              onRemove: _ctx.handleRemoveFile
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Изменения в")) + " ", 1),
                _hoisted_14,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("учредительные")) + " ", 1),
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("документы")), 1)
              ]),
              _: 1
            }, 8, ["class", "document", "is-readonly", "is-loading", "onUpload", "onRemove"])
          ], 2),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-purpose",
            value: _ctx.documents['kyb-documents-purpose'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-purpose'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-padding": false,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-purpose'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("О назначении*")) + " ", 1),
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("единоличного")) + " ", 1),
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("исполнительного")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-finance",
            value: _ctx.documents['kyb-documents-finance'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-finance'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-padding": false,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-finance'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Финансовая")) + " ", 1),
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("отчетность*")) + " ", 1),
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("(за год/за квартал)")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createVNode(_component_SharedValidate, {
            class: _normalizeClass(_ctx.b('shared-upload')),
            field: "kyb-documents-example",
            value: _ctx.documents['kyb-documents-example'].id,
            "is-validate": _ctx.isValidate,
            "is-center": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SharedUpload, {
                class: _normalizeClass(_ctx.b('shared-upload')),
                document: _ctx.documents['kyb-documents-example'],
                "is-readonly": _ctx.isReadonly,
                "is-loading": _ctx.isLoading,
                "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-example'].id,
                onUpload: _ctx.handleUploadFile,
                onRemove: _ctx.handleRemoveFile
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Карточка образцов*")) + " ", 1),
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("подписей и печатей")), 1)
                ]),
                _: 1
              }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
            ]),
            _: 1
          }, 8, ["class", "value", "is-validate"]),
          _createVNode(_component_SharedDownload, {
            class: _normalizeClass(_ctx.b('shared-download')),
            document: _ctx.displayedSignatureCard
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("Скачать карточку")), 1)
            ]),
            _: 1
          }, 8, ["class", "document"])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('download'))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass(_ctx.b('title'))
        }, _toDisplayString(_ctx.$t("Скачайте и подпишите соглашения*")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('download-groups'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('download-group'))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedQuestionnaireOfALegalEntity }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Анкета")) + " ", 1),
                _hoisted_21,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("юридического лица")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyb-documents-document",
              value: _ctx.documents['kyb-documents-document'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('download-upload')),
                  document: _ctx.documents['kyb-documents-document'],
                  "is-readonly": _ctx.isReadonly,
                  isCenter: true,
                  "is-loading": _ctx.isLoading,
                  "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-document'].id,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('download-group'))
          }, [
            _createVNode(_component_SharedDownload, { document: _ctx.displayedBrokerageAgreement }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("Брокерский")) + " ", 1),
                _hoisted_23,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("договор")), 1)
              ]),
              _: 1
            }, 8, ["document"]),
            _createVNode(_component_SharedValidate, {
              field: "kyc-personal-documents-broker",
              value: _ctx.documents['kyb-documents-broker'].id,
              "is-validate": _ctx.isValidate,
              "is-center": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SharedUpload, {
                  class: _normalizeClass(_ctx.b('download-upload')),
                  document: _ctx.documents['kyb-documents-broker'],
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  isCenter: true,
                  "is-error": _ctx.isValidate && !_ctx.documents['kyb-documents-broker'].id,
                  onUpload: _ctx.handleUploadFile,
                  onRemove: _ctx.handleRemoveFile
                }, {
                  label: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Подписанное")) + " ", 1),
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("соглашение")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "document", "is-readonly", "is-loading", "is-error", "onUpload", "onRemove"])
              ]),
              _: 1
            }, 8, ["value", "is-validate"])
          ], 2)
        ], 2)
      ], 2),
      (_ctx.isOtherShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('other'))
          }, [
            _createElementVNode("h5", {
              class: _normalizeClass(_ctx.b('title'))
            }, _toDisplayString(_ctx.$t(
            "Пожалуйста, прикрепите иные документы для подтверждения вашей верификации"
          )), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('other-documents'))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createBlock(_component_SharedUpload, {
                  key: file.uuid,
                  class: _normalizeClass(_ctx.b('other-upload')),
                  document: file,
                  "is-upload": file.isUpload,
                  "is-remove": file.isRemove,
                  "is-readonly": _ctx.isReadonly,
                  "is-loading": _ctx.isLoading,
                  onRemove: _ctx.handleRemoveAdditionalFile
                }, _createSlots({ _: 2 }, [
                  (file.name)
                    ? {
                        name: "label",
                        fn: _withCtx(() => [
                          _createTextVNode(_toDisplayString(file.name), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["class", "document", "is-upload", "is-remove", "is-readonly", "is-loading", "onRemove"]))
              }), 128)),
              (_ctx.isAddtionalUpload)
                ? (_openBlock(), _createBlock(_component_SharedUpload, {
                    key: 0,
                    class: _normalizeClass(_ctx.b('other-upload')),
                    document: _ctx.file,
                    "is-upload": _ctx.file.isUpload,
                    "is-readonly": _ctx.isReadonly,
                    "is-loading": _ctx.isLoading,
                    isCenter: true,
                    "is-label": false,
                    onUpload: _ctx.handleUploadAdditionalFile
                  }, null, 8, ["class", "document", "is-upload", "is-readonly", "is-loading", "onUpload"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('file-info'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('file-info-text'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Размер загружаемого файла — не более ")) + " ", 1),
          _hoisted_25
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('file-info-text'))
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("Поддерживаемые форматы: ")) + " ", 1),
          _hoisted_26
        ], 2)
      ], 2),
      _createVNode(_component_UIButton, {
        class: _normalizeClass(_ctx.b('continue')),
        label: "Продолжить",
        view: "main",
        disabled: _ctx.isContinueDisabled,
        onClick: _ctx.handleContinue
      }, null, 8, ["class", "disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["class"]))
}